module.exports = __webpack_public_path__ + "static/img/VDproduct1.751efc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDproduct1.png
// module id = /SsP
// module chunks = 0